'use es6';

import PropTypes from 'prop-types';
import { BaseResponsiveToolbar, buildActionsForModuleInFlexColumn } from './BaseResponsiveToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileModuleToolbarInFlexColumnToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInFlexColumn({
      isInNonDefaultBreakpointMode
    }),
    responsiveSize: responsiveSize,
    showHandleGrippie: false
  });
};
MockResponsiveMobileModuleToolbarInFlexColumnToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired
};
const MockResponsiveDesktopModuleToolbarInFlexColumnToMeasure = ({
  responsiveSize
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInFlexColumn({}),
    responsiveSize: responsiveSize,
    showHandleGrippie: false
  });
};
MockResponsiveDesktopModuleToolbarInFlexColumnToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired
};
export { MockResponsiveMobileModuleToolbarInFlexColumnToMeasure, MockResponsiveDesktopModuleToolbarInFlexColumnToMeasure };